import styled, { css } from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  overflow: hidden;
  @media (max-width: 770px) {
    flex-direction: column;
    flex-flow: column-reverse;
    justify-content: space-between;
    height: 100%;
  }
`;

export const Items = styled.div`
  @media (min-width: 769px) {
    height: 85vh;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }
  @media (max-width: 770px) {
    display: flex;
    align-items: inherit;
    width: 100%;
    height: 100%;
    margin: 0;
    flex-direction: row;
  }
`;

export const Item = styled.div`
  cursor: pointer;
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  ${({ disabled }) =>
    disabled &&
    css`
      div {
        img {
          opacity: 0.5;
        }
        span {
          opacity: 0.5;
        }
      }
    `}
  div {
    display: flex;
    margin: auto;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    img {
      z-index: 898;
      margin-bottom: 4px;

      width: 32px;
      height: 28px;
    }
    img.job-control {
      width: 40px;
    }
    img.lapidar {
      width: 32px;
      height: 28px;
    }
    span {
      text-align: center;
      color: ${props => (props.selected ? '#000FFF' : 'white')};
      ${({ titleStore }) =>
        titleStore === 'Desafio Lapidar' &&
        css`
          margin-top: -6px;
        `}
      font-size: 12px;
      line-height: 15px;
    }
  }
`;

export const NavigationContainer = styled.div`
  width: 140px;
  background-image: linear-gradient(#00ffff, #000fff);
  @media (min-width: 771px) {
    border-top-right-radius: 20px;
    border-bottom-right-radius: 20px;
  }

  @media (max-width: 770px) {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    height: 117px;
    padding-bottom: 9px;
    z-index: 50;
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 1) 51%,
      rgba(0, 15, 255, 1) 52%,
      rgba(0, 15, 255, 1) 100%
    );
    position: fixed;
    bottom: 0;
    width: 100%;
  }
`;

export const Children = styled.div`
  width: calc(100% - 140px);
  @media (max-width: 770px) {
    width: 100%;
    ${props => (props.lapidar ? 'height: 100%' : null)};
  }
`;

export const ContainerItem = styled.div`
  @media (max-width: 770px) {
    height: 4rem;
    box-shadow: none;
    ${props =>
      props.desafios &&
      !props.objectDisabled &&
      css`
        border-radius: 50%;
        padding: 6px 10px;
        width: 90% !important;
        height: 6rem !important;

        @media (max-width: 530px) {
          padding-top: 10px;
          margin-top: -18px !important;
          img {
            transform: scale(1.2) translateY(-5px);
          }
        }
        @media (min-width: 531px) and (max-width: 690px) {
          padding-top: 22px;
          margin-top: -22px !important;
          img {
            transform: scale(1.5) translateY(-5px);
          }
        }
        @media (min-width: 691px) {
          padding-top: 33px;
          margin-top: -29px !important;
          max-width: 125px;
          img {
            transform: scale(1.5) translateY(-5px);
          }
        }
      `}
    ${props =>
      props.desafios &&
      !props.selected &&
      css({
        backgroundColor: '#000FFF !important',
      })}
    ${props =>
      props.desafios &&
      props.selected &&
      css({
        backgroundColor: 'transparent !important',
      })}
    img {
      ${props =>
        props.desafios &&
        !props.objectDisabled &&
        css({
          width: '45px',
        })}
    }
    span {
      ${props =>
        props.desafios &&
        !props.objectDisabled &&
        css({
          height: '24px !important',
          display: 'flex',
          alignItems: 'center',
        })}
      ${props =>
        props.desafios &&
        !props.selected &&
        css({
          height: '30px !important',
        })}
    }
  }
  @media (max-width: 770px) and (max-height: 580px) {
    span {
      ${props =>
        props.desafios &&
        !props.selected &&
        css({
          height: '20px !important',
        })}
    }
  }

  @media (max-width: 570px) {
    /* padding-top: ${props => (props.desafios ? '3px !important' : null)}; */
  }
`;
